module.exports = __webpack_public_path__ + "static/img/peopleGame1.0a9d623.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/video/peopleGame1.png
// module id = fRq/
// module chunks = 3